import { Paper, type PaperProps } from '@mui/material';
import React from 'react';

/**
 * Shared card container used by SpaceUsageTile and Project Details inputs.
 * Provides the consistent background, padding, and centering.
 */
export const SpaceUsageCard = React.forwardRef<HTMLDivElement, PaperProps>(
  function SpaceUsageCard({ children, sx, ...rest }, ref) {
    return (
      <Paper
        ref={ref}
        {...rest}
        sx={{
          bgcolor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          p: 4,
          pt: 6,
          pb: 6,
          ...sx,
        }}
      >
        {children}
      </Paper>
    );
  },
);
